import * as React from 'react';
import { Form as FormComponent } from 'components/form/index';
import { Button, ButtonType } from 'components/button';
import { DataList } from 'components/select-advanced';
import { Input } from 'components/input/IndexAdvanced';
import CostColumnsData from '../../../views/job-costing/utils/CostColumnsData';
import { findObjById } from 'utilities/util';
import { formatDropDown, checkIfSystemType, FinOpsStatusSalesOrder, getInternalReferenceNumberError } from '../../../views/job-costing/utils/CostAndRevenueHelpers';
import { IUOM } from 'constants/uom.interface';
import Uom from 'constants/uom.json';
import { RadioButtonList } from 'components/radio-button/list';
import { BOOL_DROPDOWN } from 'constants/bool';
import { DISTRIBUTION_LIST } from 'constants/distribution';
import { PASSTHROUGH_LIST } from 'constants/passThrough';
import { ICostBooking } from 'reducers/bookings/models';
// import { PartyComponent } from './PartyComponent';
import { ICBComponent } from './ICBComponent';
import { costAndRevErrorMessage } from 'views/job-costing/utils/models';
import { SERVICE_RENDERED_OPTIONS } from 'constants/serviceRenderedOptions';
import './FormAddEdit.scss';
import { useEffect, useState } from 'react';
import { ATHENA } from 'constants/messages';
import BillToPartyComponent from 'components/bill-to-party/BillToPartyComponent';
import PayToPartyComponent from 'components/pay-to-party/PayToPartyComponent';

interface IProps {
    displayError: boolean,
    data: ICostBooking,
    propsData: ICostBooking,
    readonlyState: boolean,
    icbReadonlyState: boolean,
    target: any,
    reasonCodes: any[],
    vatPartnersData: any,
    vatPartnersOptions: any[],
    vatPartnerEditReasons: any,
    vatPartnerEditReasonSelectOptions: any[],
    type: string,
    hasSplit: boolean,
    errorList: any[],
    targetFunctionality: number,
    dropDownData: {
        chargeItem: any[],
        partyData: any;
    },
    addMoreDisable: boolean;
    onUpdate: (key: any, value: any, label?: string) => void,
    onFetchAutoRate: (errorMessage: string, athenaAdditionalfields: any) => void,
    onAthenaAdditionalFieldsUpdate: (athenaAdditionalfields: any) => void,
    onAmendRates: () => void,
    onClose: () => void,
    onAddMore: () => void,
    isQantityError: boolean,
    showPassThrough: boolean,
    isSourceAthena?: boolean;
    isRevenue: boolean;
    allowEditVatPartner: boolean;
    jobCostingExecutePermission: boolean;
    isAmendRatesEnabled: boolean;
    additionalFields: any;
    disableAthenaFields: boolean;
    enableAmendRatesButton: boolean;
    showRetriveAndAmendButtons: boolean;
    showReasonCodeDropdown: boolean;
    athenaBillToParty: any;
    athenaNetValue: any;
    isAmendingAutoRates: boolean;
    isAutoRate: boolean;
    showErrorModal: (message: string) => void;
    showServiceProvider: boolean;
    isNegativeRateAllowed: boolean;
    isInsertedByUser?: boolean;
    isSplitMode?: boolean;
    showInternalReferenceNumber?: boolean;
}

export const FormAddEdit = (props: IProps) => {
    const [athenaAdditionalfields, setFields] = useState(props.additionalFields);
    const [additionalFieldsErrorMessage, setAdditionalFieldsErrorMessage] = useState('');
    const [disableDaysField, setDisableDaysField] = useState(false);

    useEffect(() => {
        const additionalFields = props.additionalFields || [];
        const noOfDaysField = additionalFields.find((field: any) => field.key.toLowerCase().includes('days'));
        if (
            (props.type === 'edit' || props.isAmendingAutoRates) &&
            additionalFields &&
            additionalFields.length &&
            noOfDaysField &&
            !disableDaysField
        ) {
            noOfDaysField.value = '1';
            setDisableDaysField(true);
            props.onAthenaAdditionalFieldsUpdate(additionalFields);
        };
        setFields(additionalFields);
    }, [props.additionalFields, props.isAmendingAutoRates]);

    const handleAdditionalFieldsChange = (key: string, value: string) => {
        if (!athenaAdditionalfields?.length) {
            return;
        };

        const updatedFields = athenaAdditionalfields.map((field: any) => {
            if (field.key === key) {
                const updatedField = { ...field, value };

                if (field.key === 'pallettype') {
                    updatedField.hasError = false;
                    setAdditionalFieldsErrorMessage('');
                } else {
                    updatedField.hasError = !value;
                    setAdditionalFieldsErrorMessage(updatedField.hasError ? 'Field is required' : '');
                }

                if (field.type.includes('numerical') && !/^\d+$/.test(value)) {
                    updatedField.hasError = true;
                    setAdditionalFieldsErrorMessage('Please enter a valid number of days');
                }

                return updatedField;
            }
            return field;
        });

        setFields(updatedFields);
        props.onAthenaAdditionalFieldsUpdate(updatedFields);
    };

    const validateAdditionalFields = () => {
        const errorsList: string[] = [];
        if (athenaAdditionalfields && athenaAdditionalfields.length) {
            athenaAdditionalfields?.forEach((field: any) => {
                if (!field.type.includes('numerical') && !field.value && field.key !== 'pallettype') {
                    field.hasError = true;
                    errorsList.push(`${field.displayName} is required`);
                    setAdditionalFieldsErrorMessage('Field is required');
                } else if (field.type.includes('numerical') && !/^\d+$/.test(field.value)) {
                    field.hasError = true;
                    errorsList.push(`${field.displayName} please enter a valid number of days`);
                    setAdditionalFieldsErrorMessage('Please enter a valid number of days');
                }
            });
            setFields([...athenaAdditionalfields]);
        }

        return {
            errors: errorsList ? errorsList.join(',') : ''
        };
    };

    const currency = formatDropDown(CostColumnsData.DEFAULT_CURRENCY_LIST, '', '');
    const icbIndicator = BOOL_DROPDOWN;

    const uomConstants = Uom.filter((uomEl: IUOM) => uomEl.enabled).map((uomEl: IUOM) => {
        return { label: uomEl.uom, value: uomEl.uom };
    });

    const setDropDownValue = (value: string | number, obj: any, propertyName: string) => {
        const objList = findObjById(value, obj, propertyName);
        if (objList) {
            return objList;
        }
        return value;
    };

    const checkIfReadOnly = () => {
        return props.type === 'edit' &&
            (props.data.itemNumber && FinOpsStatusSalesOrder(props.data.status)) ? true : false;
    };

    const getPassThroughValue = (passThroughValue: string) => {
        return passThroughValue === 'Y' ? 1 : (passThroughValue ? 0 : -1);
    };

    const getServiceRenderedAtValue = (value: any) => {
        if (typeof value === 'string') {
            const serviceRenderedAtMap: { [key in 'ORIGIN' | 'DESTINATION' | 'FREIGHT']: number } = {
                'ORIGIN': 1,
                'DESTINATION': 2,
                'FREIGHT': 3,
            };
            return serviceRenderedAtMap[value.toUpperCase() as 'ORIGIN' | 'DESTINATION' | 'FREIGHT'] || '';
        }
        return value || '';
    };

    const checkIfSAPEdit = () => {
        return props.type === 'edit' && props.data.itemType === 'SAP'
            ? true
            : false;
    };

    if (props.data && props.data.itemType) {
        const diableVatPartnerReasonDropdown =
            props.isAutoRate ? !props.isAmendingAutoRates : props.data?.vatPartner === props.propsData?.vatPartner;
        const currentData = props.data;

        const getAdditionalFieldOptions = (field: any) => {
            if (field.key === 'pallettype') {
                return field.options[currentData.uom]?.map((item: string) => {
                    return {
                        value: item,
                        optionText: item,
                        label: item,
                    };
                });
            }
            return field.options.map((item: string) => {
                return {
                    value: item,
                    optionText: item,
                    label: item,
                };
            });
        };

        const checkIfDisabled = () => {
            return props.disableAthenaFields && props.type === 'add';
        };


        const getRadioGroupData = (name: string) => {
            if (name === 'passThrough') {
                return PASSTHROUGH_LIST.map((item: any) => {
                    return {
                        ...item,
                        isDisabled: props.disableAthenaFields && props.type === 'add',
                    };
                });
            } else if (name === 'serviceRenderedAt') {
                return SERVICE_RENDERED_OPTIONS.map((item: any) => {
                    return {
                        ...item,
                        isDisabled: props.disableAthenaFields && props.type === 'add',
                    };
                });
            }
            return [
                {
                    label: '',
                    value: null,
                    name: '',
                    isDisabled: false,
                }
            ];
        };

        const getButtons = () => {
            return <nav className="align-text-left">
                <Button
                    style={{ padding: '0.3rem' }}
                    type="button"
                    id="btn-save"
                    onClick={(e: any) => {
                        const { errors } = validateAdditionalFields();
                        props.onFetchAutoRate(errors, athenaAdditionalfields);
                    }}
                    buttonType={ButtonType.Blue}>
                    Retrieve Rates
                </Button>&nbsp;
                <Button
                    style={{ padding: '0.3rem' }}
                    type="button"
                    id="btn-cancel"
                    onClick={(e: any) => { props.onAmendRates(); }}
                    buttonType={ButtonType.Transparent}
                    isDisabled={!props.enableAmendRatesButton}>
                    Amend Rates
                </Button>
            </nav>;
        };

        const checkPalletTypeAdditionalLogic = (field: any) => {
            const allowedUOMs = field.options && Object.keys(field.options);
            const isAllowedUOM = allowedUOMs?.includes(currentData.uom) || false;
            return !isAllowedUOM;
        };

        const renderAdditionalSelectField = (field: any) => (
            <div className="jc-form-column">
                <DataList
                    key={field.key}
                    id={field.key}
                    className="col-20"
                    label={field.displayName}
                    value={field.value}
                    onChange={(e: any) => {
                        handleAdditionalFieldsChange(field.key, e);
                    }}
                    hasError={field.hasError}
                    error={additionalFieldsErrorMessage}
                    data={getAdditionalFieldOptions(field)}
                />
            </div>
        );

        const calculateAutoRateAmount = (isLocalAmount: boolean = false) => {
            const { rate, exchangeRate, quantity, specialPricingCondition } = currentData;
            const isSpecialPricingCondition = specialPricingCondition === true || specialPricingCondition === 'Y';
            const isAddMode = props.type === 'add';
            const shouldUseAthenaNetValue = props.isAutoRate && !props.isAmendingAutoRates && isSpecialPricingCondition;
            const amount = isAddMode && shouldUseAthenaNetValue ? Number(props.athenaNetValue) : validateRate(rate) * Number(quantity);
            const localAmount = amount * Number(exchangeRate);

            if (!isLocalAmount) {
                currentData.total = !isNaN(amount) ? parseFloat(amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')) : 0.00;
                return amount;
            } else {
                currentData.totalLocalCurrency = !isNaN(localAmount) ? parseFloat(localAmount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')) : 0.00;
                return localAmount;
            }
        };

        const validateRate = (rate: string | number): number => {
            if (!rate) {
                return 0;
            }
            let validatedRate: any = rate;
            if (typeof rate === 'string') {
                validatedRate = Number(rate.replace(/\,/g, ''));
            }
            return isNaN(validatedRate) ? 0 : validatedRate;
        };

        return (
            <FormComponent id="add-edit-component">
                <fieldset>
                    <div className="jc-form-container">
                        <div className="jc-form-row">
                            {!checkIfReadOnly() && props.dropDownData.chargeItem.length &&
                                <div className="jc-form-column">
                                    <DataList
                                        id="chargeItem"
                                        label={'Charge Item'}
                                        value={currentData.chargeItem}
                                        onChange={(e: any) => { props.onUpdate('chargeItem', e); }}
                                        hasError={props.errorList.indexOf('chargeItem') > -1}
                                        error="Field is required"
                                        data={checkIfReadOnly() ? [setDropDownValue(currentData.chargeItem, props.dropDownData.chargeItem, 'value')] : props.dropDownData.chargeItem}
                                    />
                                </div>
                            }

                            {checkIfReadOnly() &&
                                <div className="jc-form-column">
                                    <Input label={'Charge Item'}
                                        id="chargeItem"
                                        value={`${currentData.materialCode} - ${currentData.materialDescription}`} type="text" readonly={true} />
                                </div>
                            }

                            <div className="jc-form-column">
                                <Input label={'Unit price'}
                                    id={'unitPrice'}
                                    onChange={(e: any) => { props.onUpdate('rate', e); }}
                                    value={props.data.rate}
                                    hasError={props.errorList.indexOf('rate') > -1}
                                    formatNumber={2}
                                    pattern={
                                        props.isNegativeRateAllowed
                                            ? '^-?(?:(\\d{1,3}(?:,\\d{3}){0,2})|\\d{1,9})(?:\\.\\d{1,2})?$'
                                            : '^(?:(\\d{1,3}(?:,\\d{3}){0,2})|\\d{1,9})(?:\\.\\d{1,2})?$'
                                    }
                                    error="Field is Required, must be numeric and not exceed 9 characters and 2 decimals"
                                    type="text"
                                    disabled={checkIfDisabled()}
                                />
                            </div>

                            {currency.length > 0 &&
                                <div className="jc-form-column">
                                    <DataList
                                        id="currency"
                                        label={'Currency'}
                                        value={currentData.condCurrency}
                                        onChange={(e: any) => { props.onUpdate('condCurrency', e); }}
                                        hasError={props.errorList.indexOf('condCurrency') > -1}
                                        error="Field is Required"
                                        data={currency}
                                        isDisabled={checkIfDisabled()} />
                                </div>
                            }

                            <div className="jc-form-column">
                                <Input
                                    id={'quantity'}
                                    label={'Quantity'}
                                    onChange={(e: any) => { props.onUpdate('quantity', e); }}
                                    value={props.data.quantity}
                                    type="text"
                                    readonly={(checkIfSystemType([props.data], props.isInsertedByUser) && checkIfReadOnly()) || (!!props.isSplitMode && !props.isAmendingAutoRates)}
                                    formatNumber={3}
                                    hasError={props.errorList.indexOf('quantity') > -1}
                                    pattern="^\d{0,6}(\.\d{1,3})?$"
                                    error={props.isQantityError ? costAndRevErrorMessage.errorMsgQuantityNew : costAndRevErrorMessage.errorMsgQuantity}
                                />
                            </div>

                            {uomConstants.length > 0 &&
                                <div className="jc-form-column">
                                    <DataList
                                        label={'UOM'}
                                        id="uom"
                                        value={currentData.uom}
                                        onChange={(e: any) => { props.onUpdate('uom', e); }}
                                        hasError={props.errorList.indexOf('uom') > -1}
                                        error="Field is required"
                                        data={checkIfSystemType([props.data], props.isInsertedByUser) && checkIfReadOnly() ? [setDropDownValue(currentData.uom, uomConstants, 'value')] : uomConstants} />
                                </div>
                            }

                            <div className="jc-form-column">
                                {props.isRevenue &&
                                    <BillToPartyComponent
                                        isAdding={props.type === 'add'}
                                        billToParty={currentData.billToParty}
                                        onUpdate={props.onUpdate}
                                        errorList={props.errorList}
                                        isDisabled={props.isRevenue === true ? checkIfDisabled() : false}
                                        athenaBillToParty={props.athenaBillToParty}
                                    />
                                }
                                {!props.isRevenue &&
                                    <PayToPartyComponent
                                        vendorsApiQueryParams={props.dropDownData.partyData}
                                        isAdding={props.type === 'add'}
                                        payToParty={currentData.payToParty}
                                        onUpdate={props.onUpdate}
                                        errorList={props.errorList}
                                        isDisabled={false}
                                        showErrorModal={props.showErrorModal}
                                    />
                                }
                            </div>
                        </div>
                        <div className="jc-form-row">

                            {props.showServiceProvider && props.isRevenue && props.showRetriveAndAmendButtons && props.type === 'add' &&
                                <div className="jc-form-column">
                                    <PayToPartyComponent
                                        payToPartyLabel="Service Provider"
                                        vendorsApiQueryParams={props.dropDownData.partyData}
                                        isAdding={props.type === 'add'}
                                        payToParty={currentData.payToParty}
                                        onUpdate={props.onUpdate}
                                        errorList={props.errorList}
                                        isDisabled={false}
                                        showErrorModal={props.showErrorModal}
                                        isAthenaRateField={true}
                                    />
                                </div>
                            }

                            {props.type === 'edit' && props.targetFunctionality !== 5 &&
                                <div className="jc-form-column">
                                    <label>
                                        <input type="checkbox" name="displayDistribution"
                                            key={'displayDistribution-' + currentData.essoRateDetailId}
                                            id="displayDistribution"
                                            defaultChecked={currentData.displayDistribution}
                                            onClick={(e: any) => { props.onUpdate('displayDistribution', e.currentTarget.checked); }}
                                        /> Re-Distribute
                                    </label>
                                </div>
                            }

                            {props.hasSplit && props.data.displayDistribution && props.targetFunctionality !== 5 &&
                                <RadioButtonList
                                    className="jc-form-column"
                                    id="distribution"
                                    label="Distribution"
                                    value={currentData.distribution}
                                    hasError={props.errorList.indexOf('distribution') > -1}
                                    error="Field is required"
                                    list={DISTRIBUTION_LIST}
                                    onChange={(e: any) => { props.onUpdate('distribution', e); }}
                                />
                            }

                            {props.showPassThrough ? (checkIfSAPEdit() ? (
                                <div className="jc-form-column">
                                    <div className="form-group">
                                        <label>
                                            <span>
                                                Pass
                                                through
                                            </span>
                                        </label>
                                        <br />
                                        <span className="custom-span">
                                            {getPassThroughValue(
                                                currentData.passThrough,
                                            ) ===
                                                1
                                                ? 'Y'
                                                : 'N'}
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <RadioButtonList
                                    className="jc-form-column"
                                    id="passThrough"
                                    label="Pass Through"
                                    hasError={
                                        props.errorList.indexOf(
                                            'passThrough',
                                        ) >
                                        -1
                                    }
                                    error="Field is required"
                                    value={getPassThroughValue(
                                        currentData.passThrough,
                                    )}
                                    list={
                                        getRadioGroupData('passThrough')
                                    }
                                    onChange={(
                                        e: any,
                                    ) => {
                                        props.onUpdate(
                                            'passThrough',
                                            e,
                                        );
                                    }}
                                />
                            )) : null}

                            {props.isSourceAthena ? (currentData.updatedBy !== ATHENA ? (
                                <RadioButtonList
                                    className="jc-form-column"
                                    id="serviceRenderedAt"
                                    label="Service Rendered At"
                                    hasError={
                                        props.errorList.indexOf(
                                            'serviceRenderedAt',
                                        ) >
                                        -1
                                    }
                                    error="Field is required"
                                    value={getServiceRenderedAtValue(currentData.serviceRenderedAt)}
                                    list={
                                        getRadioGroupData('serviceRenderedAt')
                                    }
                                    onChange={(
                                        e: any,
                                    ) => {
                                        props.onUpdate(
                                            'serviceRenderedAt',
                                            Number(e),
                                        );
                                    }}
                                />
                            ) : (
                                <div className="jc-form-column">
                                    <div className="form-group">
                                        <label>
                                            <span>
                                                Service Rendered At
                                            </span>
                                        </label>
                                        <br />
                                        <span className="custom-span">
                                            {currentData.serviceRenderedAt ? currentData.serviceRenderedAt : '-'}
                                        </span>
                                    </div>
                                </div>
                            )) : null}

                            {currentData.errorReason && currentData.errorReason.length > 0 &&
                                <div className="jc-form-column">
                                    <label>
                                        <input type="checkbox"
                                            name="handleError"
                                            onChange={(e: any) => { props.onUpdate('handleError', e); }}
                                            checked={currentData.handleError ? true : false}
                                        /> Clear the following error:
                                    </label>
                                    <p className="status-red">{currentData.errorReason.toString()}</p>
                                </div>
                            }
                            {/* Vat Partner */}
                            {props.isRevenue && props.allowEditVatPartner && props.jobCostingExecutePermission &&
                                <>
                                    <div className="jc-form-column">
                                        <DataList
                                            id="vatPartner"
                                            className="col-20"
                                            label={'VAT Partner'}
                                            value={currentData.vatPartner}
                                            onChange={(e: any) => {
                                                props.onUpdate('vatPartner', e);
                                            }}
                                            isDisabled={checkIfDisabled()}
                                            hasError={false}
                                            data={props.vatPartnersOptions} />
                                    </div>

                                    <div className="jc-form-column">
                                        <DataList
                                            id="vatPartnerReasonCodeNo"
                                            className="col-20"
                                            label={'Vat Partner Edit Reason'}
                                            value={currentData.vatPartnerReasonCodeNo}
                                            isDisabled={diableVatPartnerReasonDropdown}
                                            onChange={(e: any) => {
                                                props.onUpdate('vatPartnerReasonCodeNo', e);
                                            }}
                                            hasError={props.errorList.indexOf('vatPartnerReasonCodeNo') > -1}
                                            error={costAndRevErrorMessage.validationMsgVatPartnerEditReasonCode}
                                            data={props.vatPartnerEditReasonSelectOptions} />
                                    </div>

                                </>
                            }
                            {/* Athena additional fields */}
                            {athenaAdditionalfields &&
                                <>
                                    {athenaAdditionalfields.map((field: any) => {
                                        if (field.type.startsWith('freetext')) {
                                            return (
                                                <div className="jc-form-column">
                                                    <Input
                                                        key={field.key}
                                                        label={field.displayName}
                                                        id={field.key}
                                                        className="col-20"
                                                        value={(props.isAmendingAutoRates || props.type === 'edit') ? 1 : field.value}
                                                        type="text"
                                                        hasError={field.hasError}
                                                        error={additionalFieldsErrorMessage}
                                                        onChange={(e: any) => {
                                                            handleAdditionalFieldsChange(field.key, e);
                                                        }}
                                                        disabled={(props.isAmendingAutoRates || props.type === 'edit') && disableDaysField}
                                                    />
                                                </div>
                                            );
                                        }
                                        if (field.type.startsWith('select')) {
                                            if (field.key === 'pallettype' && checkPalletTypeAdditionalLogic(field)) {
                                                return null;
                                            }
                                            return renderAdditionalSelectField(field);
                                        }
                                        return null;
                                    })}
                                </>
                            }
                            {!props.isRevenue && props.targetFunctionality !== 5 &&
                                <div className="jc-form-column">
                                    <Input
                                        label={'Vendor Reference'}
                                        id={'vendorReference'}
                                        className="col-20"
                                        value={currentData.vendorReference}
                                        type="text"
                                        onChange={(e: any) => {
                                            props.onUpdate('vendorReference', e);
                                        }}
                                    />
                                </div>
                            }
                            {props.showInternalReferenceNumber &&
                                <div className="jc-form-column">
                                    <Input
                                        label={'IRN'}
                                        id={'internalReferenceNumber'}
                                        className="col-20"
                                        value={currentData.internalReferenceNumber || ''}
                                        type="text"
                                        pattern="^[a-zA-Z0-9]{1,100}$"
                                        hasError={props.errorList.indexOf('internalReferenceNumber') > -1}
                                        error={props.errorList.indexOf('internalReferenceNumber') > -1
                                            ? getInternalReferenceNumberError(currentData.internalReferenceNumber)
                                            : ''}
                                        onChange={(e: any) => {
                                            props.onUpdate('internalReferenceNumber', e);
                                        }}
                                    />
                                </div>
                            }
                            {props.type !== 'add' &&
                                <div className="jc-form-column">
                                    <DataList
                                        id="reasonCode"
                                        className="col-20"
                                        label={'Reason Code'}
                                        value={currentData.reasonCode}
                                        onChange={(e: any) => { props.onUpdate('reasonCode', e); }}
                                        hasError={props.errorList.indexOf('reasonCode') > -1}
                                        error={costAndRevErrorMessage.validationMsgReasonCode}
                                        data={props.reasonCodes} />
                                </div>
                            }
                        </div>
                        <div className="jc-form-row">
                            {props.showRetriveAndAmendButtons && props.type === 'add' &&
                                <>
                                    <div className="jc-form-column button-group">
                                        {getButtons()}
                                    </div>
                                </>
                            }
                            {
                                props.type === 'add' && props.showRetriveAndAmendButtons && props.showReasonCodeDropdown &&
                                <div className="jc-form-column">
                                    <DataList
                                        id="reasonCode"
                                        className="col-20"
                                        label={'Reason Code'}
                                        value={currentData.reasonCode}
                                        onChange={(e: any) => { props.onUpdate('reasonCode', e); }}
                                        hasError={props.errorList.indexOf('reasonCode') > -1}
                                        error={costAndRevErrorMessage.validationMsgReasonCode}
                                        data={props.reasonCodes} />
                                </div>
                            }
                        </div>
                        <div className="jc-form-row">
                            <div className="jc-form-column">
                                <ICBComponent
                                    id="icb"
                                    className="col-20"
                                    dropdownValue={currentData.icbIndicator}
                                    isEditable={!props.icbReadonlyState}
                                    value={currentData.icbIndicator}
                                    onChange={(e: any) => { props.onUpdate('icbIndicator', e); }}
                                    hasError={props.errorList.indexOf('icbIndicator') > -1}
                                    data={icbIndicator}
                                />
                            </div>
                            <div className="jc-form-column">
                                <Input label={'Source Data'}
                                    id="sourceData"
                                    className="col-20"
                                    value={props.data.itemType} type="text" readonly={true} />
                            </div>
                            <div className="jc-form-column">
                                <Input label={'Local currency'}
                                    className="col-20"
                                    id="localCurrency"
                                    value={props.data.localCurrency} type="text" readonly={true} />
                            </div>
                            <div className="jc-form-column">
                                <Input label={'Amount'}
                                    id={'amount'}
                                    className="col-20"
                                    readonly={true}
                                    value={calculateAutoRateAmount(false)}
                                    type="text"
                                />
                            </div>
                            <div className="jc-form-column">
                                <Input label={'Exchange Rate'}
                                    id={'exchangeRate'}
                                    className="col-20"
                                    value={props.data.exchangeRate} type="text" readonly={true} />
                            </div>
                            <div className="jc-form-column">
                                <Input
                                    label={'Local Amount'}
                                    readonly={true}
                                    id={'localAmount'}
                                    className="col-20"
                                    value={calculateAutoRateAmount(true)}
                                    type="text" />
                            </div>
                        </div>
                    </div>
                </fieldset>
                {props.type === 'add' && <Button
                    type="button"
                    id="btn-addMore"
                    onClick={props.onAddMore}
                    isDisabled={props.addMoreDisable}
                    buttonType={ButtonType.Blue}>
                    Add More
                </Button>}
            </FormComponent>
        );
    } else {
        return (<div />);
    }
};